import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const highlights = [
  'فروشگاه اینترنتی کامل از ثبت محصول تا پرداخت و ارسال',
  'پنل مدیریت یکپارچه برای کل مسیر فروش',
  'چند ظاهر فروشگاهی برای برندهای مختلف',
  'بازاریابی در پیام‌رسان‌های داخلی',
  'فروش خرده، همکاری و سازمانی در یک سیستم',
];

const sections = [
  {
    id: 'shop',
    label: 'فروشگاه',
    title: 'تجربه خرید مشتری',
    items: [
      'فیلتر پیشرفته: دسته‌بندی، برند، قیمت، موجودی، تخفیف، محصولات ویژه و ویژگی‌های محصول (رنگ، سایز و …)',
      'جستجوی هوشمند و مرتب‌سازی بر اساس جدیدترین، قیمت، پرفروش، پربازدید و …',
      'محصولات ساده و چندتنوعی با قیمت، تخفیف و موجودی جداگانه',
      'حالت «تماس برای استعلام قیمت» برای محصولات خاص',
      'گالری تصویر، محصولات مرتبط و نمایش بازدید و فروش',
      'نمای سریع، علاقه‌مندی، مقایسه محصولات',
      'ثبت شماره برای اطلاع هنگام موجود شدن کالا',
    ],
  },
  {
    id: 'checkout',
    label: 'خرید',
    title: 'سبد خرید و پرداخت',
    items: [
      'سبد خرید پایدار با بررسی لحظه‌ای قیمت و موجودی',
      'انتخاب آدرس، استان و شهر',
      'کد تخفیف با قوانین پیشرفته',
      'محاسبه هزینه ارسال و ارسال رایگان',
      'تحویل حضوری بدون هزینه ارسال',
      'پرداخت آنلاین با کارت بانکی (زرین‌پال و بانک ملت)',
      'پرداخت کارت‌به‌کارت با آپلود رسید و تأیید مدیر',
      'خرید اقساطی و اعتباری (ترب‌پی و اسنپ‌پی)',
      'پیگیری وضعیت پرداخت و سفارش',
    ],
  },
  {
    id: 'account',
    label: 'مشتری',
    title: 'حساب کاربری',
    items: [
      'ورود با رمز عبور یا کد یکبار مصرف پیامکی',
      'بازیابی رمز عبور',
      'پروفایل و مدیریت چند آدرس',
      'تاریخچه سفارشات',
      'لیست علاقه‌مندی و مقایسه محصولات',
      'قیمت اختصاصی برای همکاران فروش',
    ],
  },
  {
    id: 'admin',
    label: 'مدیریت',
    title: 'پنل مدیریت فروشگاه',
    items: [
      'داشبورد: آمار فروش، سفارشات، درآمد، پرفروش‌ها و پربازدیدها',
      'مدیریت کامل محصولات، تنوع‌ها، دسته‌بندی و برند',
      'ویرایش گروهی قیمت، موجودی، تخفیف و وضعیت محصولات',
      'خروجی و واردات اکسل محصولات',
      'مدیریت سفارشات، فاکتور PDF و لیبل پستی',
      'تأیید پرداخت کارت‌به‌کارت',
      'تعریف روش‌های ارسال و رهگیری مرسوله',
      'کد تخفیف با قوانین پیشرفته',
      'مدیریت کاربران، نقش‌ها و دسترسی‌ها',
      'تنظیمات فروشگاه، درگاه‌ها، ارسال و شبکه‌های اجتماعی',
    ],
  },
  {
    id: 'content',
    label: 'محتوا',
    title: 'محتوا و بازاریابی',
    items: [
      'اسلایدر و بنر تبلیغاتی',
      'صفحه فرود قابل سفارش‌سازی',
      'منو و مگامنو چندسطحی',
      'صفحات درباره ما، قوانین و حریم خصوصی',
      'وبلاگ با دسته‌بندی و نظرات',
      'سوالات متداول',
      'اشتراک شماره موبایل برای اطلاع از تخفیف‌ها',
      'بهینه‌سازی برای موتورهای جستجو',
      'نمایش نماد اعتماد الکترونیکی (اینماد)',
    ],
  },
  {
    id: 'social',
    label: 'بازاریابی',
    title: 'شبکه‌های اجتماعی و فروش',
    items: [
      'ارسال محصول به روبیکا، ایتا و بله با یک کلیک',
      'متن و تصویر خودکار همراه لینک محصول',
      'ارسال گروهی محصولات از پنل',
      'اطلاع‌رسانی خودکار هنگام برگشت موجودی به کانال‌ها',
      'اتصال به باسلام و ثبت لینک دیجی‌کالا',
      'پیامک تأیید سفارش و اطلاع ارسال',
    ],
  },
  {
    id: 'inventory',
    label: 'انبار',
    title: 'مدیریت موجودی',
    items: [
      'مدیریت موجودی چند انباری',
      'تأمین‌کنندگان و رزرو موجودی',
      'هشدار کمبود و نقطه سفارش مجدد',
      'گزارش‌های انبار با خروجی اکسل و PDF',
      'هماهنگی موجودی با سیستم‌های خارجی',
    ],
  },
  {
    id: 'b2b',
    label: 'B2B',
    title: 'فروش همکار و سازمانی',
    items: [
      'قیمت اختصاصی برای همکاران',
      'حداقل تعداد خرید همکار',
      'سازمان‌های طرف قرارداد با کمپین تخفیف',
      'تولید انبوه کد تخفیف سازمانی',
      'گزارش مصرف کمپین‌ها',
    ],
  },
  {
    id: 'support',
    label: 'پشتیبانی',
    title: 'پشتیبانی و بازخورد',
    items: [
      'تیکت پشتیبانی با اولویت‌بندی',
      'نظرات محصول با امتیاز و تأیید خرید',
      'اعلان‌های درون‌برنامه‌ای، ایمیل و پیامک',
      'گزارش فروش روزانه، هفتگی و ماهانه',
    ],
  },
];

const differentiators = [
  'همه‌کاره واقعی — از کاتالوگ تا پرداخت اقساطی، انبار و پیام‌رسان',
  'چند روش پرداخت ایرانی: آنلاین، کارت‌به‌کارت، اقساطی',
  'بازاریابی در روبیکا، ایتا و بله',
  'اتوماسیون موجودی و اطلاع‌رسانی خودکار',
  'فروش B2B و B2C در یک پلتفرم',
  'محتوا، بلاگ و سئو برای رشد ارگانیک',
  'گزارش پربازدید، پرفروش و منبع ورود مشتری',
  'چند تم فروشگاهی — یک سیستم، چند برند',
];

const audiences = [
  'فروشگاه‌های پوشاک و مد',
  'لوازم خانگی و دکور',
  'فروش عمده و B2B',
  'فروش سازمانی',
  'هر کسب‌وکاری که به فروش آنلاین حرفه‌ای نیاز دارد',
];

const quotes = [
  'فروشگاهی که محصول را می‌فروشد، به کانال‌های شما معرفی می‌کند، و وقتی دوباره موجود شد — خودش خبر می‌دهد.',
  'از ورود مشتری تا فاکتور و ارسال — یک پنل، کل مسیر فروش.',
  'هر محصولی که بفروشید، مخاطبانتان در پیام‌رسان می‌بینند.',
];

const SectionBlock = ({ label, title, items }) => (
  <section className="scroll-mt-20">
    <p className="text-teal-400 text-sm font-medium mb-1">{label}</p>
    <h2 className="text-xl sm:text-2xl font-bold text-white mb-4">{title}</h2>
    <ul className="space-y-2.5">
      {items.map((item, i) => (
        <li key={i} className="flex gap-3 text-slate-300 text-sm sm:text-base leading-relaxed">
          <span className="text-teal-500 mt-1.5 flex-shrink-0 w-1.5 h-1.5 rounded-full bg-teal-500" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  </section>
);

const ShopPage = () => {
  const navigate = useNavigate();

  const goToPortfolio = () => {
    navigate('/');
    setTimeout(() => {
      document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  return (
    <div className="min-h-screen bg-slate-900">
      <Header />

      {/* Hero */}
      <section className="relative py-16 sm:py-24 overflow-hidden border-b border-slate-800">
        <div className="absolute top-20 right-10 w-72 h-72 bg-teal-500/10 rounded-full blur-3xl" />
        <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10">
          <Link to="/" className="text-slate-400 hover:text-teal-400 text-sm mb-6 inline-block transition-colors">
            ← بازگشت به خانه
          </Link>
          <p className="text-teal-400 text-sm font-medium mb-3">سیستم فروشگاه آنلاین آلتو</p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight max-w-3xl">
            فروشگاه اینترنتی{' '}
            <span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">
              کامل و یکپارچه
            </span>
          </h1>
          <p className="text-slate-400 mt-5 text-lg max-w-2xl leading-relaxed">
            از ثبت محصول و فروش آنلاین تا پرداخت، ارسال، بازاریابی در شبکه‌های اجتماعی،
            مدیریت انبار و گزارش‌گیری — همه در یک اکوسیستم قابل مدیریت برای کسب‌وکار شما.
          </p>
          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {highlights.map((h, i) => (
              <li key={i} className="flex items-start gap-2 text-slate-300 text-sm">
                <svg className="w-5 h-5 text-teal-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                {h}
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Main sections */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-16 sm:py-20 space-y-16 sm:space-y-20">
        {sections.map((section) => (
          <div
            key={section.id}
            id={section.id}
            className="bg-slate-800/50 rounded-xl p-6 sm:p-8 border border-slate-700/50"
          >
            <SectionBlock {...section} />
          </div>
        ))}

        {/* Differentiators */}
        <section className="bg-gradient-to-br from-teal-900/30 to-slate-800/80 rounded-xl p-6 sm:p-8 border border-teal-500/20">
          <p className="text-teal-400 text-sm font-medium mb-1">چرا آلتو؟</p>
          <h2 className="text-xl sm:text-2xl font-bold text-white mb-6">نقاط تمایز</h2>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {differentiators.map((d, i) => (
              <li key={i} className="flex gap-3 text-slate-300 text-sm">
                <span className="text-teal-400 font-bold">{String(i + 1).padStart(2, '0')}</span>
                <span>{d}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Audience */}
        <section>
          <p className="text-teal-400 text-sm font-medium mb-1">مناسب برای</p>
          <h2 className="text-xl sm:text-2xl font-bold text-white mb-4">چه کسب‌وکارهایی؟</h2>
          <div className="flex flex-wrap gap-2">
            {audiences.map((a, i) => (
              <span key={i} className="bg-slate-800 text-slate-300 px-4 py-2 rounded-lg text-sm border border-slate-700">
                {a}
              </span>
            ))}
          </div>
        </section>

        {/* Quotes */}
        <section className="space-y-4">
          {quotes.map((q, i) => (
            <blockquote
              key={i}
              className="border-r-4 border-teal-500 pr-4 text-slate-400 italic text-sm sm:text-base leading-relaxed"
            >
              «{q}»
            </blockquote>
          ))}
        </section>
      </div>

      {/* CTA */}
      <section className="py-16 sm:py-20 bg-slate-800/80 border-t border-slate-700/50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">
            آماده راه‌اندازی فروشگاه آنلاین هستید؟
          </h2>
          <p className="text-slate-400 mb-8 max-w-lg mx-auto">
            برای مشاوره رایگان و دیدن نمونه‌کارها با ما در تماس باشید.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/09134378347"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-500 text-white px-6 py-3.5 rounded-lg text-sm font-medium transition-colors"
            >
              درخواست مشاوره
            </a>
            <button
              type="button"
              onClick={goToPortfolio}
              className="inline-flex items-center gap-2 text-slate-300 hover:text-teal-400 border border-slate-600 hover:border-teal-500/50 px-6 py-3.5 rounded-lg text-sm font-medium transition-colors"
            >
              مشاهده نمونه‌کارها
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ShopPage;
